import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClinicRadiologyServicesDetailsMaster = createAsyncThunk(
  "clinicRadiologyServicesDetailsMaster/getClinicRadiologyServicesDetailsMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicRadiologyServicesDetailsMaster/getClinicRadiologyServicesDetailsMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClinicRadiologyServicesDetailsMaster = createAsyncThunk(
  "clinicRadiologyServicesDetailsMaster/updateClinicRadiologyServicesDetailsMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/clinicRadiologyServicesDetailsMaster/updateClinicRadiologyServicesDetailsMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const deleteRadiologyServiceDetails = createAsyncThunk(
  "clinicRadiologyServicesDetailsMaster/deleteRadiologyServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/clinicRadiologyServicesDetailsMaster/deleteRadiologyServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  radiologyServicesDetails: [],
  loading: false,
  searchMessage: null,
  updateRadiologyMaterSuccessMessage: null,
  updateRadiologyMaterErrorMessage: null,
  deleteRadiologyMaterSuccessMessage: null,
  deleteRadiologyMaterErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const clinicRadiologyMasterSlice = createSlice({
  name: "clinicRadiologyServicesDetailsMaster",
  initialState,
  reducers: {
    retsetUpdateRadiologyMaterMessage: (state) => {
      state.updateRadiologyMaterSuccessMessage = null;
      state.updateRadiologyMaterErrorMessage = null;
    },
    resetDeleteRadiologyMaterMessage: (state) => {
      state.deleteRadiologyMaterSuccessMessage = null;
      state.deleteRadiologyMaterErrorMessage = null;
    },
    resetgetRadiologyServicesDetails: (state) => {
      state.radiologyServicesDetails = [];
      state.searchMessage = null;
      state.totalRecords = 0;
      state.currentPage = 1;
      state.totalPages = null;
      state.hasMore = true;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getClinicRadiologyServicesDetailsMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClinicRadiologyServicesDetailsMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.radiologyServicesDetails = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.radiologyServicesDetails = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getClinicRadiologyServicesDetailsMaster.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateClinicRadiologyServicesDetailsMaster.pending, (state) => {
        state.loading = true;
        state.updateRadiologyMaterSuccessMessage = null;
        state.updateRadiologyMaterErrorMessage = null;
      })
      .addCase(updateClinicRadiologyServicesDetailsMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateRadiologyMaterErrorMessage = action.payload.result.message;
        } else {
          state.updateRadiologyMaterSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicRadiologyServicesDetailsMaster.rejected, (state, action) => {
        state.loading = false;
        state.updateRadiologyMaterErrorMessage = action.payload.result.message;
      })
      .addCase(deleteRadiologyServiceDetails.pending, (state) => {
        state.loading = true;
        state.deleteRadiologyMaterSuccessMessage = null;
        state.deleteRadiologyMaterErrorMessage = null;
      })
      .addCase(deleteRadiologyServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteRadiologyMaterErrorMessage = action.payload.result.message;
        } else {
          state.deleteRadiologyMaterSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteRadiologyServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.deleteRadiologyMaterErrorMessage = action.payload.result.message;
      });
  },
});

export const { retsetUpdateRadiologyMaterMessage, resetDeleteRadiologyMaterMessage, resetgetRadiologyServicesDetails } = clinicRadiologyMasterSlice.actions;

export default clinicRadiologyMasterSlice.reducer;